import { useFilters } from '../../Common/Hooks/useFilters'
import { Player, Spirit } from '../../Common/SI'

export interface PlayerAsSpiritLinkProps {
	children: JSX.Element | JSX.Element[] | string
	player: Player
	spirit: Spirit
}

export function PlayerAsSpiritLink(props: PlayerAsSpiritLinkProps): JSX.Element {

	const { addFilter } = useFilters()

	return (
		// eslint-disable-next-line jsx-a11y/anchor-is-valid
		<a className='filter' href='#' onClick={(e) => {
			e.preventDefault()
			addFilter('playersAsSpirits', `${props.player.name} as ${props.spirit.nickname}`)
		}}>{props.children}</a>
	)
}
